import React from "react";
import { useEffectOnce, useSharedState } from "hooks";
import { Chart } from "react-google-charts";
import styles from "./Home.module.css";
import { Help } from "components/search/Help";

import { statsService, alertService } from "services";

const Home = () => {
  const [stats] = useSharedState(statsService.stats);
  useEffectOnce(() => {
    async function fetchAll() {
      try {
        await statsService.patents.authors();
        await statsService.patents.owners();
        await statsService.publications.publishers();
        await statsService.publications.venues();
        await statsService.publications.fos();
        await statsService.publications.keywords();
        await statsService.publications.language();
        await statsService.histogram();
      } catch (e) {
        if (e.name === "AbortError" || e instanceof DOMException) {
          console.warn(e);
          return;
        }
        alertService.error(
          "Cannot load all Statistics. Please reload the page or try later."
        );
      }
    }
    if (stats.length === 0) {
      fetchAll();
    }
    return () => {
      statsService.abort();
    };
  });
  return (
    <div className={styles.container}>
      <div className={`card-columns ${styles.wrapper}`}>
        <div className="card">
          <div className="card-body">
            <p className="card-text">
              <strong>
                KnowING <abbr title="Intellectual Property Rights">IPR</abbr>{" "}
                project
              </strong>{" "}
              is generally focused on the topic of technology transfer and
              specifically with the topic of management of intellectual property
              rights as a factor of innovation. To reach the aims of the project
              we are building an institutional platform (
              <em>supported by online platform</em>), where different
              stakeholders will be able to retrieve information on importance of
              technology transfer, <abbr title="Intellectual Property">IP</abbr>{" "}
              protection, opportunities arising from{" "}
              <abbr title="Intellectual Property">IP</abbr> protection and on
              tools to properly manage own{" "}
              <abbr title="Intellectual Property">IP</abbr>. The goal of the
              project is to improve cooperation{" "}
              <abbr title="Small or Medium Enterprises">SMEs</abbr> and research
              institutions through empowerment of stakeholders with knowledge on
              recognition and utilization of{" "}
              <abbr title="Intellectual Property">IP</abbr> protection.
            </p>
          </div>
          <div className="card-footer">
            <small>
              Project co-funded by European Union Funds (ERDF, IPA, ENI)
              <br />
              Projectwebsite:{" "}
              <a
                href="http://www.interreg-danube.eu/knowing-ipr"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.interreg-danube.eu/knowing-ipr
              </a>
            </small>
          </div>
        </div>
        <div className="card">
          <Help />
        </div>
        {stats.map((stat, i) => (
          <div key={stat.id} className="card">
            <div className="card-body">
              <h3 className={styles.title}>{stat.title}</h3>
              <Chart
                className={styles.chart}
                chartType={stat.chartType}
                data={stat.data}
                options={stat.options}
                legendToggle
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { Home };
